import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import { patientsQueryOptions } from "../../../../features/patients/queries"

const patientSearchSchema = z.object({
  search: z.string().optional().catch(""),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
  facility: z.coerce.number().optional().catch(undefined),
  primaryClinician: z.coerce.number().optional().catch(undefined),
  isActive: z.coerce.boolean().optional().catch(undefined),
  onlyAssigned: z.coerce.boolean().optional().catch(undefined),
  diagnosis_ids: z.string().optional().catch(undefined),
  ordering: z.string().default("-last_health_update_at"),
  is_warning: z.coerce.boolean().optional().catch(undefined),
  has_unread_messages: z.coerce.boolean().optional().catch(undefined),
  is_charted_today: z.coerce.boolean().optional().catch(undefined),
  is_diary_filled_today: z.coerce.boolean().optional().catch(undefined),
  has_sleep_apnea: z.coerce.boolean().optional().catch(undefined),
  has_unacknowledged_health_summaries: z.coerce.boolean().optional().catch(undefined),
})

export const Route = createFileRoute("/_app/manage/patients/")({
  validateSearch: (search: SearchSchemaInput) =>
    patientSearchSchema.parse(search),

  loaderDeps: ({ search }) => search,

  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      patientsQueryOptions({ params: { query: deps } })
    )
  },
})
